import NotificationCenter from './container/NotificationCenter';

export default NotificationCenter;
